import { render } from "./InstanceCreate.vue?vue&type=template&id=d6dbe8c2"
import script from "./InstanceCreate.vue?vue&type=script&lang=js"
export * from "./InstanceCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__